import { createContext,useContext, useReducer} from "react";
import reducer from "../Reducer/neReducer";
const NewsEventContext=createContext();


const initialState ={
     news_event:[],
}



const NewsEventProvider =({children})=>{
     const [state,disptach]=useReducer(reducer,initialState)
     const  getNewsEvent = (newsEvent)=>{
          disptach({type:"ADD_NEWS_EVENT",payload:{newsEvent}})
   };

   
return (
     <NewsEventContext.Provider value={{...state, getNewsEvent}}>
     {children}
     </NewsEventContext.Provider>
);
};

const useNewsEventContext=()=>{
     return useContext(NewsEventContext);
}

export {NewsEventProvider,useNewsEventContext};